import {VatRate} from "../../libs/enum/vat-rate.enum";
import {VatRateState} from "../../libs/enum/vat-rate-state";
import {isDefined} from "../../libs/utils/epic.utils";

export class VatRateDto {

  public id!: string;
  public vatRate!: VatRate;
  public value!: number;
  public validFrom: Date | undefined;
  public validUntil: Date | undefined;
  public readonly state!: VatRateState;
  public readonly oldPart!: boolean;

  constructor(init?: Partial<VatRateDto> | undefined) {
    Object.assign(this, init);
    if (isDefined(init?.validFrom)) {
      this.validFrom = new Date(init?.validFrom);
    }
    if (isDefined(init?.validUntil)) {
      this.validUntil = new Date(init?.validUntil);
    }
  }
}
